import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { formatCurrency } from '../../../utils/currency';

const DeleteConfirmationModal = ({ isOpen, onClose, onConfirm, entry }) => {
  if (!isOpen || !entry) return null;

  const isPosted = entry?.status?.toLowerCase() === 'posted';

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-1030 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg shadow-2xl w-full max-w-md">
        <div className="p-4 md:p-6">
          <div className="flex items-start gap-4 mb-4 md:mb-6">
            <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-error/10 flex items-center justify-center flex-shrink-0">
              <Icon name="AlertTriangle" size={24} color="var(--color-error)" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground mb-2">
                Delete Journal Entry?
              </h3>
              <p className="font-body text-sm md:text-base text-muted-foreground mb-3">
                Are you sure you want to delete journal entry "{entry?.entryNumber}"?
              </p>
              <div className="text-sm text-muted-foreground space-y-1">
                <p><span className="font-medium">Description:</span> {entry?.description}</p>
                <p><span className="font-medium">Amount:</span> {formatCurrency(entry?.totalDebit)}</p>
                <p><span className="font-medium">Status:</span> {entry?.status}</p>
              </div>
            </div>
          </div>

          {isPosted && (
            <div className="bg-warning/10 border border-warning/20 rounded-md p-4 mb-4 md:mb-6">
              <div className="flex items-start gap-3">
                <Icon name="AlertCircle" size={20} color="var(--color-warning)" className="flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="font-body font-medium text-sm text-foreground mb-2">
                    Warning
                  </p>
                  <p className="caption text-muted-foreground">
                    This journal entry has been posted and may affect your financial reports and general ledger.
                  </p>
                </div>
              </div>
            </div>
          )}

          <div className="bg-muted/20 rounded-md p-3 mb-4 md:mb-6">
            <p className="text-xs text-muted-foreground text-center">
              This action cannot be undone. The journal entry and all its line items will be permanently deleted.
            </p>
          </div>

          <div className="flex flex-col-reverse md:flex-row gap-3">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              fullWidth
              className="md:flex-1"
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="destructive"
              onClick={() => {
                onConfirm(entry.id);
                onClose();
              }}
              fullWidth
              className="md:flex-1"
              iconName="Trash2"
              iconPosition="left"
            >
              Delete Entry
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;